export default "__VITE_ASSET__BkR7PJqA__"